export const coerceToNumber = (
  value: string | number | boolean | undefined | null,
): number | undefined => {
  if (typeof value === "number") {
    return value;
  }

  if (typeof value === "string") {
    const numberValue = parseFloat(value);
    return isNaN(numberValue) ? undefined : numberValue;
  }

  if (typeof value === "boolean") {
    return value ? 1 : 0;
  }

  return undefined;
};
